import { IDepositInfo } from '../../../types';

export const defaultValue: IDepositInfo = {
  data: {
    id: 0,
    title: '',
    short_description: '',
    description: '',
    side: 0,
    minutes: 0,
    sets: 0,
    expiry_at: null,
    balance: '',
    resource_price: null,
    pay_order_id: null,
    pay_order_created_at: null,
    rent_pay_count: null
  }, type: 3
}; // Устанавливает радиокнопку по-умолчанию на ден. деп.